import React from "react";
import {Row,Col} from "react-bootstrap"
import { Link } from "react-router-dom";
import ll from "../assets/ll.png";
import Aos from "aos";
import "aos/dist/aos.css";

 
const Footer=()=>{
    Aos.init({
        duration:2000,
        disable: 'mobile'
    })
    return(
        <>
        <div style={{backgroundColor:"#ddb6c6",backgroundSize:"100% 100%",minHeight:"450px",paddingTop:"20px",display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",
                }}>
            <div className="container">
                    <Row>
                        <Col md={4} sm={6} xs={12}>
                            <center><h3> Speak-Out! </h3></center>
                            <center><p style={{fontSize:"18px",fontWeight:"400"}}>Tell the world your success stories through our platform. How you rose above gender disparity and motivate someone who is going through that phase. Your words can pick up someone who might have lost all hope in herself/himself.</p></center>
                        </Col>
                        <Col md={4} sm={6} xs={12}>
                            <center><h3>Navigation</h3></center>
                            <center>
                                <p>
                                <Link to="/" style={{fontSize:"18px",fontWeight:"400",color:"#393A38",margin:"3px"}}>Home</Link>
                                <Link to="/about" style={{fontSize:"18px",fontWeight:"400",color:"#393A38",margin:"3px"}}>About</Link>
                                <Link to="/blog" style={{fontSize:"18px",fontWeight:"400",color:"#393A38",margin:"3px"}} >Blog</Link> 
                                <Link to="/contact" style={{fontSize:"18px",fontWeight:"400",color:"#393A38",margin:"3px"}} >Contact</Link>
                                </p>
                            </center>
                        </Col>
                        <Col md={4} sm={6} xs={12}>
                         
                        <center><h3>Address</h3></center> 
                        <center><p style={{fontSize:"18px",fontWeight:"400"}}> Plot . 2902/ 4941
                            Akash Tower

                            New Delhi

                            Pin . 110059 Vikas Puri , New Delhi

                            phone:-+91 9873749579, +91 9999074363

                            <p><a href="mailto:shefoundationorg@gmail.com"> email- shefoundationorg@gmail.com</a></p> </p>
                        </center>
                        </Col>
                    </Row>

            </div>
        </div>
        <div style={{backgroundColor:"#5C5D5B",backgroundSize:"100% 100%",minHeight:"100px",paddingTop:"20px" ,
        paddingBottom:"0px",paddingLeft:"20px",paddingRight:"20px"
        
                }}>
                    <Row>
                        <Col md={6} sm={12}>
                        <p style={{textAlign:"left",fontWeight:"700"}}>@ 2020 S(HE)- Foundation. All Right Reserved.</p>
                        </Col>
                        <Col md={6} sm={12}>
                        <p style={{textAlign:"right"}}>
                    <a href="https://www.linkedin.com/company/s-he-foundation"><i style={{color:"#37B1E1",marginRight:"5px"}} class="fab fa-linkedin fa-2x"></i></a>
                    <a href="https://www.facebook.com/SHE-Foundation-101500238366305/?view_public_for=101500238366305"><i style={{color:"#4B69B0",marginRight:"5px"}} class="fab fa-facebook fa-2x"></i></a>
                    <a href="https://www.instagram.com/shefoundationorg/?hl=en"> <i style={{color:"#2BA63A",marginRight:"5px"}} class="fab fa-instagram-square fa-2x"></i></a>

                    </p>
                        </Col>
                    </Row>

        </div>

        </>
    )
}
export default Footer;